import React from "react";

function CTAPreview({
  buttonLabel,
  isActive,
}) {

  return (
    <div className="card">

      <div className="card-header bg-white">

        <h5 className="mb-1">
          Live Preview
        </h5>

        <small className="text-muted">
          Preview how the CTA will appear in chat.
        </small>

      </div>


      <div className="card-body">

        <div className="chat-preview">

          {/* Chat Header */}

          <div className="chat-header">

            <div className="bot-avatar">
              🤖
            </div>

            <div>

              <strong>
                ChatBizz AI
              </strong>

              <small>
                ● Online
              </small>

            </div>

          </div>


          {/* Chat Body */}

          <div className="chat-body">

            <div className="bot-message">

              Hi! 👋

              <br />

              How can I help you today?

            </div>


            <div className="bot-message mt-3">

              Would you like to learn more
              about our services?

            </div>


            {/* CTA */}

            <button
              className="btn btn-primary w-100 mt-3"
              disabled={!isActive}
            >

              {buttonLabel || "CTA Button"}

            </button>


            {!isActive && (
              <small className="text-muted d-block text-center mt-2">
                CTA is currently inactive
              </small>
            )}

          </div>

        </div>

      </div>

    </div>
  );
}

export default CTAPreview;